import { useEffect } from "react";

import { useDisclosure } from "@alpacahq/ui/old";

import { useGetOwnerDetails } from "~/v2/api/hooks";
import { useGetBillingOverview } from "~/v2/api/hooks/useGetBillingOverview";
import { Path } from "~/v2/path";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { withAppBasePath } from "~/v2/utils/appBasePath";
import { getCookie, setCookie } from "~/v2/utils/cookies";

const MESSAGE_KEY = "MARKET_DATA_SUBSCRIPTION_PLAN";

export const useOpraAgreementModalController = () => {
  const disclosure = useDisclosure();
  const OPRAMessageDismissed = getCookie(MESSAGE_KEY);

  const { product } = useAccountContext();
  const isLive = product === "live";

  // This modal is a live-only feature, so only fetch billing for live accounts
  const { billing } = useGetBillingOverview({
    options: {
      enabled: isLive,
    },
  });
  const { details } = useGetOwnerDetails();

  useEffect(() => {
    // Is live, has a plan
    if (isLive && billing?.plan && details) {
      // Hasn't signed the agreement
      if (
        OPRAMessageDismissed !== "true" &&
        !details?.opra_agreement_signed_at
      ) {
        disclosure.onOpen();
      }
    }
  }, [isLive, billing?.plan, details, OPRAMessageDismissed, disclosure.onOpen]);

  const onDismiss = () => {
    setCookie(MESSAGE_KEY, "true");
    disclosure.onClose();
  };

  const onViewAndSign = () => {
    window.location.href = withAppBasePath(Path.ROUTE_MARKET_DATA_OVERVIEW);
  };

  return {
    isOpen: disclosure.isOpen,
    onClose: disclosure.onClose,
    onDismiss,
    onViewAndSign,
  };
};
